/** Tenants that start file checks via agentic missions (not self-serve assess). */
export const AGENTIC_CASE_CHECK_CLIENT_IDS = new Set(["soderberg", "progeny"]);

const CASE_CHECK_AGENT_NAMES: Record<string, string> = {
  soderberg: "Soren",
  progeny: "Marvin",
};

/** Lead agent display name for agentic file-check missions. */
export function caseCheckAgentName(companyId: string | undefined): string {
  return (companyId && CASE_CHECK_AGENT_NAMES[companyId]) ?? "Marvin";
}

export function usesAgenticCaseCheck(companyId: string | undefined): boolean {
  return Boolean(companyId && AGENTIC_CASE_CHECK_CLIENT_IDS.has(companyId));
}

const OUTCOMES_TENANT_IDS = new Set(["progeny", "soderberg"]);

/** Tenants with an outcomes catalog and coverage review APIs. */
export function supportsOutcomesCatalog(companyId: string | undefined): boolean {
  return Boolean(companyId && OUTCOMES_TENANT_IDS.has(companyId));
}

const FILE_REVIEW_EXPORT_TENANT_IDS = new Set(["progeny"]);

/** Tenants with a Word file-review / coverage-review template (API enforces the same list). */
export function supportsFileReviewExport(companyId: string | undefined): boolean {
  return Boolean(companyId && FILE_REVIEW_EXPORT_TENANT_IDS.has(companyId));
}

/** @deprecated Use supportsOutcomesCatalog */
export function usesProgenyProblemStatements(companyId: string | undefined): boolean {
  return supportsOutcomesCatalog(companyId);
}

/** Outcomes coverage tab in the review shell. */
export function usesOutcomesCoverageTab(companyId: string | undefined): boolean {
  return supportsOutcomesCatalog(companyId);
}

/** @deprecated Use usesOutcomesCoverageTab */
export function usesProgenyCoverageTab(companyId: string | undefined): boolean {
  return usesOutcomesCoverageTab(companyId);
}

/** Guided review shell (Summary · workflow · outcomes) for Progeny and Soderberg. */
export function usesGuidedReviewShell(companyId: string | undefined): boolean {
  return supportsOutcomesCatalog(companyId);
}

/** @deprecated Use usesGuidedReviewShell */
export function usesProgenyReviewShell(companyId: string | undefined): boolean {
  return usesGuidedReviewShell(companyId);
}
